.divider {
  height: 1px;
  width: 100%;
  background-color: var(--gray-l);
}